import React from 'react'
import { makeStyles } from '@material-ui/core'
import GlueButton from '../glueos-components/glue-button'
import GlueIcon from '../glueos-components/glue-icon'
import InputField from './input-field'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'
import { useHistory } from 'react-router-dom'
import LoadingIndicator from '../glueos-components/loading-indicator'
import LoginPageTemplate from './login-page-template'
import OtherLoginButton from './other-login-button'
import { loginWithGoogle } from '../../services/login'

const useStyles = makeStyles(theme => ({
  loginTitle: {
    height: '64px',
    display: 'flex',
    alignItems: 'flex-end'
  },

  loginWithEmail: {
    display: 'flex',
    flexFlow: 'column'
  },

  inputs: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('s'),
    paddingTop: theme.spacing('l'),
    paddingBottom: theme.spacing('xl')
  },

  emailLoginButtons: {
    display: 'flex',
    flexFlow: 'row',
    gap: theme.spacing('l'),
    justifyContent: 'flex-end'
  },

  otherLoginOptions: {
    display: 'flex',
    flexFlow: 'column'
  },

  otherLoginButtons: {
    display: 'flex',
    flexFlow: 'column',
    gap: theme.spacing('s'),
    paddingTop: `calc(${theme.spacing('l')} * 2)`
  },

  createOrgBox: {
    height: '100%',
    borderRadius: '32px',
    background: theme.palette.background.paper,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  createOrgContent: {
    width: '1110px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },

  createOrgInfoText: {
    display: 'flex',
    gap: theme.spacing('s'),
    width: '544px'
  }
}), { name: 'MuiGlueLoginPageTablet' })

const LoginPageTablet = (props) => {
  const classes = useStyles()
  const history = useHistory()

  const loginWithEmail = (
    <div className={classes.loginWithEmail}>
      <div className={classes.loginTitle}>
        <h1>Log in with email</h1>
      </div>
      <div className={classes.inputs}>
        <InputField width='100%' label='Email' type='email' value={props.email} onChange={(value) => { props.setEmail(value); props.setInputError(null) }} error={props.inputError} onSubmitKey={!props.usePasswordLogin ? props.onPressNextButton : null} />
        {props.usePasswordLogin && (
          <InputField width='100%' label='Password' type='password' value={props.password} onChange={(value) => { props.setPassword(value); props.setInputError(null) }} error={!!props.inputError && ' '} onSubmitKey={props.onPressLoginButton} />
        )}
      </div>
      <div className={classes.emailLoginButtons}>
        {props.usePasswordLogin ? (
          <>
            <GlueButton color='stealth' width='288px' onPointerDown={props.openPasswordDialog}>Forgot password</GlueButton>
            <GlueButton color='primary' width='200px' onPointerDown={props.onPressLoginButton}>
              { props.loading ? (
                <LoadingIndicator variant='button' />
              ) : (
                <p>Log in</p>
              )}
            </GlueButton>
          </>
        ) : (
          <>
            <GlueButton disabled={!props.email} color='primary' width='200px' onPointerDown={props.onPressNextButton}>
              { props.loading ? (
                <LoadingIndicator variant='button' />
              ) : (
                <p>Next</p>
              )}
            </GlueButton>
          </>
        )}
      </div>
    </div>
  )

  const otherLoginOptions = (
    <div className={classes.otherLoginOptions}>
      <div className={classes.loginTitle}>
        <h2>Other login options</h2>
      </div>
      <div className={classes.otherLoginButtons}>
        <OtherLoginButton iconSrc='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/LoginIcon_Glue.png' onPointerDown={() => props.setCodeDialogOpen(true)}>Glue Device Code</OtherLoginButton>
        <OtherLoginButton iconSrc='https://glue-public-static-resources.s3-eu-west-1.amazonaws.com/web-images/LoginIcon_Google.png' onPointerDown={loginWithGoogle}>Log in with Google</OtherLoginButton>
      </div>
    </div>
  )

  const createOrgBox = (
    <div className={classes.createOrgBox}>
      <div className={classes.createOrgContent}>
        <div className={classes.createOrgInfoText}>
          <GlueIcon><ErrorOutlineIcon /></GlueIcon>
          <p>Starting fresh? The first thing you&apos;ll need is to create a new organization in Glue.</p>
        </div>
        <GlueButton width='432px' color='secondary' onPointerDown={() => history.push('/create-org')}>Create a new organization</GlueButton>
      </div>
    </div>
  )

  return (
    <>
      <LoginPageTemplate
        leftSideContent={loginWithEmail}
        rightSideContent={otherLoginOptions}
        bottomContent={createOrgBox}
      />
    </>
  )
}

export default LoginPageTablet
